export const fetchSubmissionByRef = async (refLink) => {
  const res = await fetch("https://petros-global.com/ems/backend/submission/fetchByRef.php?refLink=" + refLink, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
}